import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";

import { SettingContent } from "../styled/setting";
import { defaultMenuGroup, status } from "../function/store";

import MenuGroupList from "./menuGroup/menuGroupList";
import EditGroup from "./menuGroup/editMenuGroup";
import AddGroup from "./menuGroup/addMenuGroup";
import LinkProducts from "./menuGroup/modal/linkProducts";
import ProductManager from "./menuGroup/modal/productManager";
import OrderGroup from "./menuGroup/modal/orderGroup";
import axios from "axios";

const MenuGroup = ({
  selectCompany,
  menuGroups,
  openModal,
  closeModal,
  products,
  getMenuGroup,
  domain,
  clickImages,
  getProducts,
  categoriesObj,
  optionGroup,
}) => {
  const [selected, setSelected] = useState(defaultMenuGroup());
  const [menuGroup, setMenuGroup] = useState(defaultMenuGroup());
  const [context, setContext] = useState({ type: "", id: null, parentId: null });
  const [active, setActive] = useState(0);
  const [dialog, setDialog] = useState("");

  const transformValue = (active ? 1 : 0) * -100;

  const changeTab = (idx, item = null) => {
    setActive(idx);
    setSelected(item);
    if (item) {
      setMenuGroup({ ...item, menuPlatform: item.menuPlatform ? item.menuPlatform : "PICKUP" });
    }
  };

  const closeForm = () => {
    setMenuGroup(defaultMenuGroup());
    changeTab(0);
  };

  const toggleModal = (type = "", item = null) => {
    if (item) setSelected(item);
    setDialog((data) => (type && type === data ? "" : type));
  };

  const changeStatus = (type, item) => {
    if (item.status === type) return;

    openModal({
      type: "confirmation",
      title: "상품 상태 변경",
      message: [
        `${chooseParticle(item.name, "을를")} ${chooseParticle(
          status[type],
          "으로",
        )} 변경하시겠습니까?`,
      ],
      handleConfirm: () => updateProduct({ ...item, status: type }),
    });
  };

  const updateProduct = async (product) => {
    const url = "/erp/vendorProducts/update";
    const { id, ...rest } = product;

    const body = { id: id, input: { ...rest, cmpnyNo: selectCompany.value } };
    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        toast.success("상품 상태가 변경되었습니다");
        await getProducts();
        await getMenuGroup();
      }
    } catch (error) {
      toast.error("잠시 후 다시 시도해주세요");
    } finally {
      closeModal();
    }
  };

  const renderModal = () => {
    switch (dialog) {
      case "link":
        return (
          <LinkProducts
            toggleModal={toggleModal}
            products={products}
            menuGroup={menuGroup}
            setMenuGroup={setMenuGroup}
          />
        );
      case "product":
        return (
          <ProductManager
            menuGroup={selected}
            toggleModal={toggleModal}
            products={products}
            openModal={openModal}
            closeModal={closeModal}
            clickImages={clickImages}
            getProducts={getProducts}
            categoriesObj={categoriesObj}
            selectCompany={selectCompany}
            optionGroup={optionGroup}
            getMenuGroup={getMenuGroup}
            changeStatus={changeStatus}
          />
        );
      case "order":
        return (
          <OrderGroup
            data={menuGroups}
            toggleModal={toggleModal}
            selectCompany={selectCompany}
            getMenuGroup={getMenuGroup}
            context={context}
            setContext={setContext}
            changeTab={changeTab}
            openModal={openModal}
            closeModal={closeModal}
            clickImages={clickImages}
          />
        );
    }
  };

  return (
    <SettingContent>
      {dialog && renderModal()}
      <div className="slideWrapper">
        <MenuGroupList
          transformValue={transformValue}
          data={menuGroups}
          changeTab={changeTab}
          context={context}
          setContext={setContext}
          openModal={openModal}
          closeModal={closeModal}
          selectCompany={selectCompany}
          getMenuGroup={getMenuGroup}
          clickImages={clickImages}
          toggleModal={toggleModal}
          changeStatus={changeStatus}
        />
        <div className="slideContent" style={{ transform: `translateX(${transformValue}%)` }}>
          {
            [
              <EditGroup
                closeForm={closeForm}
                selected={selected}
                toggleModal={toggleModal}
                menuGroup={menuGroup}
                setMenuGroup={setMenuGroup}
                openModal={openModal}
                closeModal={closeModal}
                getMenuGroup={getMenuGroup}
                selectCompany={selectCompany}
                domain={domain}
              />,
              <AddGroup
                closeForm={closeForm}
                toggleModal={toggleModal}
                menuGroup={menuGroup}
                setMenuGroup={setMenuGroup}
                openModal={openModal}
                closeModal={closeModal}
                getMenuGroup={getMenuGroup}
                selectCompany={selectCompany}
                domain={domain}
              />,
            ][active ? active - 1 : active]
          }
        </div>
      </div>
    </SettingContent>
  );
};

export default MenuGroup;
